(function(m, ei, q, i, a, j, s) {
    m[i] = m[i] || function() {
            (m[i].a = m[i].a || []).push(arguments)
        };
    j = ei.createElement(q),
        s = ei.getElementsByTagName(q)[0];
    j.async = true;
    j.charset = 'UTF-8';
    j.src = '//static.meiqia.com/dist/meiqia.js';
    s.parentNode.insertBefore(j, s);
})(window, document, 'script', '_MEIQIA');
_MEIQIA('entId', 7797);
_MEIQIA('withoutBtn');



// WEBPACK FOOTER //
// ./src/assets/js/meiqia.js